import { ServerConfig } from "@/config/config";
import { Job } from "@/models/job";
import { Axios } from "@/utils/axios";

export interface IClearfactsSaleSyncStatus {
	ID: number;
	WinfaktSaleID: number;
	DocumentUUID: string;
	Status: string;
	LastError: string;
	Attempts: number;
	LastSyncedAt: string;
}

export interface IClearfactsPurchaseSyncStatus {
	ID: number;
	WinfaktPurchaseID: number;
	BookYear: number;
	DocumentUUID: string;
	Status: string;
	LastError: string;
	Attempts: number;
	LastSyncedAt: string;
}

export interface IExportToClearfactsOptions {
	documentType?:"sales" | "purchases";
	bookYear?:number;
	beginDate?:Date;
	endDate?:Date;
	journalIds?:number[];
	saleIds?:number[];
	purchaseIds?:number[];
	includeAlreadySynced?:boolean;
}

export interface IClearfactsExportError {
	FriendlyID:string;
	Error:string;
}

export interface IClearfactsExportResult {
	Created:number;
	Skipped:number;
	Failed:number;
	Errors:IClearfactsExportError[];
	Canceled:boolean;
}

export interface IClearfactsRunSummary {
	Created:number;
	Skipped:number;
	Failed:number;
	Errors:IClearfactsExportError[];
}

export interface IClearfactsDossierRunResult {
	Sales:IClearfactsRunSummary;
	Purchases:IClearfactsRunSummary;
}

export class ClearfactsSyncServiceClass {
	private readonly baseUrl:string = `${ServerConfig.host}/clearfacts`;

	async pushSale(saleId:number):Promise<{DocumentUUID:string, Uploaded:number}>{
		let result = await Axios.post(`${this.baseUrl}/push-sale/${saleId}`);
		return result.data;
	}

	async getSaleSync(saleId:number):Promise<IClearfactsSaleSyncStatus | null>{
		let result = await Axios.get(`${this.baseUrl}/sale-sync/${saleId}`);
		return result.data || null;
	}

	async pushPurchase(purchaseId:number, bookYear:number):Promise<{DocumentUUID:string, Uploaded:number}>{
		let result = await Axios.post(`${this.baseUrl}/push-purchase/${purchaseId}?bookYear=${bookYear}`);
		return result.data;
	}

	async getPurchaseSync(purchaseId:number, bookYear:number):Promise<IClearfactsPurchaseSyncStatus | null>{
		let result = await Axios.get(`${this.baseUrl}/purchase-sync/${purchaseId}?bookYear=${bookYear}`);
		return result.data || null;
	}

	async exportPeriod(options:IExportToClearfactsOptions = {}):Promise<Job>{
		let body = {
			documentType: options.documentType || "sales",
			bookYear: options.bookYear || 0,
			beginDate: options.beginDate,
			endDate: options.endDate,
			journalIds: options.journalIds || [],
			saleIds: options.saleIds || [],
			purchaseIds: options.purchaseIds || [],
			includeAlreadySynced: options.includeAlreadySynced || false
		};
		let result = await Axios.post(`${this.baseUrl}/export-period`, body);
		return new Job(result.data);
	}

	async runAutoSyncNow(date?:string):Promise<IClearfactsDossierRunResult>{
		let url = `${this.baseUrl}/run-auto-sync`;
		if (date) url += `?date=${date}`;
		let result = await Axios.post(url);
		return result.data;
	}
}

export const ClearfactsSyncService = new ClearfactsSyncServiceClass();
